import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { AppLayout } from "./components/layout";
import { ProtectedRoute } from "./components/common";
import {
  HomePage,
  PreviewPage,
  LoginPage,
  DashboardPage,
  ServicesPage,
  ServiceDetailPage,
  InstancesPage,
  InstanceDetailPage,
  SettingsPage,
} from "./pages";

const App: React.FC = () => {
  return (
    <Routes>
      {/* Public routes - login is standalone (no sidebar) */}
      <Route path="/login" element={<LoginPage />} />

      {/* Routes with layout (sidebar) */}
      <Route element={<AppLayout />}>
        {/* Public pages - visible to logged-out users */}
        <Route path="/" element={<HomePage />} />
        <Route path="/preview" element={<PreviewPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:id" element={<ServiceDetailPage />} />

        {/* Protected pages - require authentication */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/instances" element={<InstancesPage />} />
          <Route
            path="/instances/:instanceId"
            element={<InstanceDetailPage />}
          />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
